import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserInfoPanel from '../budgetAuth/UserInfoPanel';
import { actions as authActions } from '../../actions/budgetAuthActions';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import LoadingIndicator from '../LoadingIndicator';
import ParticipantApplications from './ParticipantApplications';
import { actions as budgetActions } from '../../actions/budgetActions';

class ParticipantApplicationsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.actions.loadMyApplications();
  }

  render() {
    const { auth, fetching, applications} = this.props;

    return (
      <React.Fragment>
        <div key="top" className="row top">
          <div className="col-sm-2" />
          <div className="col-sm-3" />
          <div className="col-sm-7 header">
            <UserInfoPanel auth={auth} authenticationRequired={true}
              authActions={this.props.authActions} account={this.props.account} />
              <a href="/budzet-obywatelski" className="btn"><i className="fa fa-long-arrow-alt-left" /> powrót</a>
          </div>
        </div>
        <div key="content" style={{ marginTop: 40, marginBottom: 40 }}>
          <LoadingIndicator fetching={fetching}>
            <Paper style={{ overflowX: 'auto' }}>
              <ParticipantApplications applications={applications} />
            </Paper>
          </LoadingIndicator>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantApplicationsPage.propTypes = {
  auth: PropTypes.object,
  actions: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  account: PropTypes.object,
  fetching: PropTypes.bool,
  applications: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    auth: state.budgetAuth,
    account: state.budgetAccount.data,    
    fetching: state.budgetApplications.fetching,
    applications: state.budgetApplications.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantApplicationsPage);



// WEBPACK FOOTER //
// ./src/components/budget/ParticipantApplicationsPage.js